import { BaseDecorator } from './base.decorator'
import { ExamRegistration } from 'models'
import * as moment from 'moment';

export class ExamRegistrationDecorator extends BaseDecorator {

    constructor(protected object: ExamRegistration) {
        super(object)
    }

    licenseIssuedAt(format: string): string {
        return this.object && this.object.licenseIssuedAt.isValid() ? this.object.licenseIssuedAt.format(format) : ''
    }

    scheduledAt(format: string): string {
        return this.object && this.object.scheduledAt ? this.object.scheduledAt.format(format) : ''
    }

    hiddenPhone(): string {
        if (!(this.object && this.object.phone)) {
            return '';
        }
        return this.object.phone.toString().replace(/(\d{2})(\d+)(\d{4})/,'$1*****$3')
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/decorators/exam-registration.decorator.ts